const initKretoGallery = (scope = document) => {
  scope.querySelectorAll('[data-kreto-gallery]').forEach((gallery) => {
    if (gallery.dataset.initialized) return;
    gallery.dataset.initialized = 'true';
    const main = gallery.querySelector('[data-kreto-gallery-main]');
    gallery.querySelectorAll('[data-kreto-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        main.src = thumb.dataset.large;
        main.alt = thumb.dataset.alt;
        gallery.querySelectorAll('[data-kreto-gallery-thumb]').forEach((item) => {
          item.classList.toggle('is-active', item === thumb);
          item.setAttribute('aria-pressed', item === thumb ? 'true' : 'false');
        });
      });
    });
  });
};
document.addEventListener('DOMContentLoaded', () => initKretoGallery());
document.addEventListener('shopify:section:load', (event) => initKretoGallery(event.target));
